import React, { useEffect } from 'react';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { useHasPermissions } from 'components/accessControl/hooks/useHasPermissions';
import { PricingAdministrationPage } from './PricingAdministrationPage';
import { useAppDispatch } from 'store/store';
import {
  getSummaryUnderwriterProfilesV2Action,
  getUnderwriterProfileDetailSlice,
} from 'store/administration/pricing/slices';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/types';
import { initializeQueryStateUnderwriterProfiles } from 'utilities/administration/underwriterProfileQueryManagement';
import { defaultUnderwriterProfileData } from 'types/administration/pricing/underwriterProfileInterfaces/IUnderwriterProfile';
import { useLocation } from 'react-router-dom';
import { PermissionWrapper } from '../../../components/accessControl/PermissionWrapper';

// At this time, there is no database table for an underwriter;
// thus, everything here is a DTO => JSON => javascript object.
//
// Observe that the data set is relatively large and un-paginated
// This is because Timber pagination responses do not exist in the Services.
// (The services do not use Spring Boot, which has the pagination). ¯\_(ツ)_/¯

export const PricingAdministrationContainer: React.FC = () => {
  const hasReadPermission = useHasPermissions([ePermissions.AuthIdentityRead]);
  const dispatch = useAppDispatch();
  const { getSummaryUnderwriterProfilesV2 } = useSelector((store: RootStore) => store.pricing);
  const location = useLocation();

  useEffect(() => {
    if (hasReadPermission) {
      dispatch(getSummaryUnderwriterProfilesV2Action(initializeQueryStateUnderwriterProfiles(location.search)));
      dispatch(getUnderwriterProfileDetailSlice.actions.reset(defaultUnderwriterProfileData));
    }
  }, [dispatch, hasReadPermission, location.search]);
  return (
    <PermissionWrapper allowedPermissions={[ePermissions.AuthIdentityRead]}>
      <PricingAdministrationPage fetchDataState={getSummaryUnderwriterProfilesV2} />
    </PermissionWrapper>
  );
};
